import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-44d51ed2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modal_call_out_record_import",
  ref: "hsCodeImportModalRef",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered mw-650px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "fw-bolder" }
const _hoisted_6 = {
  id: "kt_call_out_record_close",
  "data-bs-dismiss": "modal",
  class: "btn btn-icon btn-sm btn-active-icon-primary"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body scroll-y mx-5 mx-xl-15 my-7" }
const _hoisted_9 = { class: "svg-icon svg-icon-5tx svg-icon-primary" }
const _hoisted_10 = { class: "el-upload__text" }
const _hoisted_11 = { class: "el-upload__tip text-red" }
const _hoisted_12 = { class: "modal-footer flex-center" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "indicator-label" }
const _hoisted_15 = { class: "svg-icon svg-icon-3 ms-0 me-2" }
const _hoisted_16 = { class: "indicator-progress" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.t("hsCodeManagement.importHsCode")), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createVNode(_component_el_upload, {
            class: "multiple-drag-upload",
            drag: "",
            accept: ".xls,.xlsx",
            "file-list": _ctx.fileList,
            "onUpdate:file-list": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fileList) = $event)),
            action: _ctx.uploadUrl,
            headers: _ctx.uploadHeaders,
            limit: 1,
            "auto-upload": false,
            "on-success": _ctx.handleUploadSuccess,
            "on-change": _ctx.handleChange,
            "on-remove": _ctx.handleRemove,
            ref: "uploadRef"
          }, {
            tip: _withCtx(() => [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t("hsCodeManagement.uploadTip")), 1)
            ]),
            default: _withCtx(() => [
              _createElementVNode("span", _hoisted_9, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/files/fil022.svg" })
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createTextVNode(_toDisplayString(_ctx.t("common.uploadDrop")) + " ", 1),
                _createElementVNode("em", null, _toDisplayString(_ctx.t("common.uploadClick")), 1)
              ])
            ]),
            _: 1
          }, 8, ["file-list", "action", "headers", "on-success", "on-change", "on-remove"])
        ])), [
          [_directive_loading, _ctx.loading]
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("button", {
            ref: "submitButton",
            type: "button",
            class: "btn btn-lg btn-primary",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.submitImport && _ctx.submitImport(...args))),
            disabled: _ctx.loading || _ctx.fileList.length == 0
          }, [
            _createElementVNode("span", _hoisted_14, [
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
              ]),
              _createTextVNode(" " + _toDisplayString(_ctx.t("common.submit")), 1)
            ]),
            _createElementVNode("span", _hoisted_16, [
              _createTextVNode(_toDisplayString(_ctx.t("common.pleaseWait")) + " ", 1),
              _hoisted_17
            ])
          ], 8, _hoisted_13)
        ])
      ])
    ])
  ], 512))
}